import React, { useState, useCallback } from "react";
import { Combobox } from "../../../../../../Components";
import { TbPlane } from "react-icons/tb";
import { get } from "../../../../../../Utils/axios";
import apis from "../../../../../../Utils/apis";
import { StampToDate, StampTo24hr } from "../../../../../../Utils/utils";
import { debounce } from "../../../../../../Utils/utils";

export default function BookingSelect({ onSelect = () => {}, selected = {}, label = "Tag expense to flight booking (Optional)", className = "" }) {
	const [bookings, setBookings] = useState([]);
	const [loading, setLoading] = useState(false);

	// Debounced search function
	const debouncedSearch = useCallback(
		debounce((query) => {
			if (query.trim().length >= 2) {
				searchBookings(query);
			} else {
				setBookings([]);
			}
		}, 300),
		[]
	);

	const searchBookings = (searchQuery) => {
		setLoading(true);
		get(
			apis.getBookedFlightBookings,
			{
				search: searchQuery,
				page: 1,
				dates: {
					startDate: new Date(Date.now() - 182 * 24 * 60 * 60 * 1000), // 6 months ago
					endDate: new Date(), // today
				},
			},
			(response, error) => {
				setLoading(false);
				if (response) {
					setBookings(response.bookings || []);
				} else if (error) {
					console.error("Error searching bookings:", error);
					setBookings([]);
				}
			}
		);
	};

	return (
		<Combobox
			label={label}
			placeholder="Search flight bookings"
			className={className}
			onChange={(query) => debouncedSearch(query)}
			options={bookings.map((booking) => ({
				...booking,
				label: `${booking.departureCode}-${booking.arrivalCode} | ${booking.airlineCode}-${booking.flightNumber}`,
				value: booking.id,
			}))}
			selected={selected}
			onSelect={onSelect}
			loading={loading}
			icon={<TbPlane />}
			renderItem={(booking, active, selectedState) => (
				<li key={booking.id} className={`p-3 hover:bg-light ${active ? "bg-light" : ""}`}>
					<div className="flex gap-x-3 items-center w-full">
						<div className="flex-shrink-0">
							<img
								src={`https://cdn.travelwings.com/globalassets/images/${booking.airlineCode?.toUpperCase()}.jpg`}
								alt={booking.airlineCode}
								className="w-8 h-8 rounded-full"
								onError={(e) => {
									e.target.src =
										"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 24 24'%3E%3Cpath fill='%23ccc' d='M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z'/%3E%3C/svg%3E";
								}}
							/>
						</div>
						<div className="flex-grow">
							<div className="flex justify-between items-center">
								<div className="text-sm font-medium">
									{booking.airlineCode}-{booking.flightNumber}
								</div>
								<div className="text-xs text-gray-500">{StampToDate(booking.departureTime)}</div>
							</div>
							<div className="flex justify-between items-center mt-1">
								<div className="text-sm text-gray-600">
									{booking.departureCode} → {booking.arrivalCode}
								</div>
								<div className="text-xs text-gray-500">
									{StampTo24hr(booking.departureTime)} - {StampTo24hr(booking.arrivalTime)}
								</div>
							</div>
						</div>
					</div>
				</li>
			)}
		/>
	);
}
